import React from 'react';
import NotificationsPage from '../Notificaciones/NotificationsPage';
import NavigationSecurity from '../Layouts/Navigation/NavigationSecurity';

export default function SecurityNotificaciones() {
  return <NotificationsPage NavigationComponent={NavigationSecurity} />;
}
